module.exports = __webpack_public_path__ + "img/bottom_phone.a2c9049e.png";